// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.not-found {
  max-width: 1328px;
  padding: 0 24px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 95px;
}

.not-found--heading {
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 32px;
}

.not-found--heading h2 {
  max-width: 642px;
}

.not-found--heading h2 span {
  color: var(--color-primary-red);
}

.not-found--info {
  width: 100%;
  background-color: var(--color-primary-light-gray);
  padding: 56px;
  border: 1.5px solid var(--color-primary-offwhite);
  border-radius: 24px;
  color: var(--color-contrast-dark-gray);
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.not-found--info .p2-paragraph {
  color: var(--color-primary-red);
}

@media (max-width: 768px) {
  .not-found--info {
    padding: 40px 32px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/404.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,iDAAiD;EACjD,aAAa;EACb,iDAAiD;EACjD,mBAAmB;EACnB,sCAAsC;EACtC,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF","sourcesContent":[".not-found {\n  max-width: 1328px;\n  padding: 0 24px;\n  margin: 0 auto;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 95px;\n}\n\n.not-found--heading {\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 32px;\n}\n\n.not-found--heading h2 {\n  max-width: 642px;\n}\n\n.not-found--heading h2 span {\n  color: var(--color-primary-red);\n}\n\n.not-found--info {\n  width: 100%;\n  background-color: var(--color-primary-light-gray);\n  padding: 56px;\n  border: 1.5px solid var(--color-primary-offwhite);\n  border-radius: 24px;\n  color: var(--color-contrast-dark-gray);\n  display: flex;\n  flex-direction: column;\n  gap: 18px;\n}\n\n.not-found--info .p2-paragraph {\n  color: var(--color-primary-red);\n}\n\n@media (max-width: 768px) {\n  .not-found--info {\n    padding: 40px 32px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
